import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e5dae68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "modalSSIRS"
}
const _hoisted_4 = { class: "contenedorSSIRS" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Escáner SIRS ")
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"color":"white"},
  class: "fas fa-download"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "contenidoSSIRS" }
const _hoisted_10 = { class: "contenidoSSIRS" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "modal7"
}
const _hoisted_13 = { class: "contenedor7" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, " Seleccione el Centro ", -1))
const _hoisted_15 = { class: "contenido7" }
const _hoisted_16 = { class: "contenido7" }
const _hoisted_17 = { id: "customers" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "NOMBRE"),
  /*#__PURE__*/_createElementVNode("th", null, "REGION"),
  /*#__PURE__*/_createElementVNode("th", null, "PROVINCIA")
], -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "general" }
const _hoisted_21 = {
  key: 0,
  class: "modalConfirm"
}
const _hoisted_22 = { class: "contenedor" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Notificación", -1))
const _hoisted_24 = { class: "contenido" }
const _hoisted_25 = { class: "contenido" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Afiliado Validado Exitosamente ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos del Afiliado")
], -1))
const _hoisted_28 = { class: "grid" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cedula"
}, "CEDULA:", -1))
const _hoisted_30 = { class: "lds-ripple" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombre"
}, "NOMBRE:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "apellido"
}, "APELLIDO:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "sexo"
}, "SEXO:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "MASCULINO", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "FEMENINO", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaNacimiento"
}, "NACIMIENTO:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "edad"
}, "EDAD:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nss"
}, "NSS:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "regimen"
}, "REGIMEN:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SUBSIDIADO", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "CONTRIBUTIVO", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PENSIONADO", -1))
const _hoisted_47 = [
  _hoisted_44,
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "direccion"
}, "DIRECCION:", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telefono"
}, "TELEFONO:", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo_de_contacto"
}, "TIPO DE CONTACTO:", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PROPIO", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PROMOTOR DE SALUD", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "GESTOR DE SALUD", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "OTROS", -1))
const _hoisted_55 = [
  _hoisted_51,
  _hoisted_52,
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo_de_contacto"
}, "ESPECIFIQUE:", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombre_contacto"
}, "NOMBRE DE CONTACTO:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de la Evaluación")
], -1))
const _hoisted_59 = { class: "grid" }
const _hoisted_60 = { class: "grid" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fecha"
}, "FECHA:", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "unap"
}, "UNAP:", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "supervisor"
}, "SUPERVISOR:", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombre_doctor"
}, "MEDICO:", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Medidas Antropométricas")
], -1))
const _hoisted_66 = { class: "grid" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "talla"
}, "TALLA (cm):", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "peso"
}, "PESO (Kg):", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cintura"
}, "CINTURA (cm):", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "abdomen"
}, "ABDOMEN (cm):", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cadera"
}, "CADERA (cm):", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "altura_rodilla"
}, "ALTURA DE RODILLA (cm):", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Evaluación Funcional")
], -1))
const _hoisted_74 = { class: "grid" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "presion_arterial_sistolica"
}, "P.A. SISTOLICA (mmHg):", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "presion_arterial_diatolica"
}, "P.A. DIASTOLICA (mmHg):", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "frecuencia_cardiaca"
}, "FRECUENCIA CARDIACA (l/m):", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fuerza"
}, "FUERZA (Kg):", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "estadoFuerza"
}, "ESTADO FUERZA:", -1))
const _hoisted_80 = { class: "grid" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "imc"
}, "IMC:", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "estadoImc"
}, "ESTADO IMC:", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "flexibilidad_miembro_superior"
}, "FLEX. MIEMBROS SUPERIORES:", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "flexibilidad_miembro_inferior"
}, "FLEX. MIEMBROS INFERIORES:", -1))
const _hoisted_85 = { class: "grid" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "pliegue_bicep"
}, "PLIEGUE DE BICEPS (mm):", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "pliegue_abdominal"
}, "PLIEGUE ABDOMINAL (mm):", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "pliegue_sub"
}, "PLIEGUE SUBESCAPULAR (mm):", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "pctoGrasa"
}, "% GRASA:", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Tamizaje Nutricional Adulto Mayor")
], -1))
const _hoisted_91 = { class: "grid-oneLine selects" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_1" }, " 1.¿TIENE ALGUNA ENFERMEDAD O CONDICIÓN QUE LE HA HECHO CAMBIAR LA CLASE O LA CANTIDAD DE ALIMENTO QUE CONSUME? ", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_95 = [
  _hoisted_93,
  _hoisted_94
]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_2" }, "2.¿COME MENOS DE 2 COMIDAS AL DÍA?", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_99 = [
  _hoisted_97,
  _hoisted_98
]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_3" }, " 3.¿COME POCAS FRUTAS, VEGETALES O PRODUCTOS DE LECHE? ", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_103 = [
  _hoisted_101,
  _hoisted_102
]
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_4" }, " 4.¿TOMA TRES O MÁS BEBIDAS DE CERVEZA, LICORES O VINO CASI TODOS LOS DÍAS? ", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_107 = [
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_5" }, " 5.¿TIENE PROBLEMAS CON LOS DIENTES O LA BOCA QUE LE DIFICULTAN COMER? ", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_111 = [
  _hoisted_109,
  _hoisted_110
]
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_6" }, " 6.¿SIEMPRE TIENE SUFICIENTE DINERO PARA COMPRAR LOS ALIMENTOS QUE NECESITAS? ", -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_115 = [
  _hoisted_113,
  _hoisted_114
]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_7" }, " 7.¿COME A SOLAS LA MAYOR PARTE DE LAS VECES?: ", -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_119 = [
  _hoisted_117,
  _hoisted_118
]
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_8" }, " 8.¿TOMA AL DÍA TRES O MÁS MEDICINAS DIFERENTES, CON O SIN RECETA? ", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_123 = [
  _hoisted_121,
  _hoisted_122
]
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_9" }, " 9.¿HA GANADO O PERDIDO PESO, SIN QUERER, 4,5 KG (10 LIBRAS) EN LOS ÚLTIMOS 6 MESES? ", -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_127 = [
  _hoisted_125,
  _hoisted_126
]
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_10" }, " 10.¿FÍSICAMENTE PUEDE IR DE COMPRAS, COCINAR O ALIMENTARSE? ", -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_131 = [
  _hoisted_129,
  _hoisted_130
]
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_10" }, " RIESGO NUTRICIONAL ", -1))
const _hoisted_133 = { class: "radios" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_1"
}, " 1.¿TIENE ALGUNA ENFERMEDAD O CONDICIÓN QUE LE HA HECHO CAMBIAR LA CLASE O LA CANTIDAD DE ALIMENTO QUE CONSUME? ", -1))
const _hoisted_135 = { class: "form-check grid-radio" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_1"
}, "SI", -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_1"
}, "NO", -1))
const _hoisted_138 = { class: "radios" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_2"
}, " 2.¿COME MENOS DE 2 COMIDAS AL DÍA? ", -1))
const _hoisted_140 = { class: "form-check grid-radio" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_2"
}, "SI", -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_2"
}, "NO", -1))
const _hoisted_143 = { class: "radios" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_3"
}, " 3.¿COME POCAS FRUTAS, VEGETALES O PRODUCTOS DE LECHE? ", -1))
const _hoisted_145 = { class: "form-check grid-radio" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_3"
}, "SI", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_3"
}, "NO", -1))
const _hoisted_148 = { class: "radios" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_4"
}, " 4.¿TOMA TRES O MÁS BEBIDAS DE CERVEZA, LICORES O VINO CASI TODOS LOS DÍAS? ", -1))
const _hoisted_150 = { class: "form-check grid-radio" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_4"
}, "SI", -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_4"
}, "NO", -1))
const _hoisted_153 = { class: "radios" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_5"
}, " 5.¿TIENE PROBLEMAS CON LOS DIENTES O LA BOCA QUE LE DIFICULTAN COMER? ", -1))
const _hoisted_155 = { class: "form-check grid-radio" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_5"
}, "SI", -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_5"
}, "NO", -1))
const _hoisted_158 = { class: "radios" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_6"
}, " 6.¿SIEMPRE TIENE SUFICIENTE DINERO PARA COMPRAR LOS ALIMENTOS QUE NECESITAS? ", -1))
const _hoisted_160 = { class: "form-check grid-radio" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_6"
}, "SI", -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_6"
}, "NO", -1))
const _hoisted_163 = { class: "radios" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_7"
}, " 7.¿COME A SOLAS LA MAYOR PARTE DE LAS VECES? ", -1))
const _hoisted_165 = { class: "form-check grid-radio" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_7"
}, "SI", -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_7"
}, "NO", -1))
const _hoisted_168 = { class: "radios" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_8"
}, " 8.¿TOMA AL DÍA TRES O MÁS MEDICINAS DIFERENTES, CON O SIN RECETA? ", -1))
const _hoisted_170 = { class: "form-check grid-radio" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_8"
}, "SI", -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_8"
}, "NO", -1))
const _hoisted_173 = { class: "radios" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_9"
}, " 9.¿HA GANADO O PERDIDO PESO, SIN QUERER, 4,5 KG (10 LIBRAS) EN LOS ÚLTIMOS 6 MESES? ", -1))
const _hoisted_175 = { class: "form-check grid-radio" }
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_9"
}, "SI", -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_9"
}, "NO", -1))
const _hoisted_178 = { class: "radios" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_10"
}, " 10.¿FÍSICAMENTE PUEDE IR DE COMPRAS, COCINAR O ALIMENTARSE? ", -1))
const _hoisted_180 = { class: "form-check grid-radio" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_10"
}, "SI", -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_10"
}, "NO", -1))
const _hoisted_183 = { class: "radios" }
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "eval_nutri_10" }, " RIESGO NUTRICIONAL ", -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Hallazgos, Situación Actual del Paciente")
], -1))
const _hoisted_186 = { class: "grid" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "Encamado"
}, "ENCAMADO:", -1))
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_190 = [
  _hoisted_188,
  _hoisted_189
]
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "Edentulo"
}, "EDENTULO:", -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_194 = [
  _hoisted_192,
  _hoisted_193
]
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "vive solo"
}, "VIVE SOLO:", -1))
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_198 = [
  _hoisted_196,
  _hoisted_197
]
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "abandono"
}, "ABANDONO:", -1))
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_202 = [
  _hoisted_200,
  _hoisted_201
]
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "maltrato"
}, "MALTRATO:", -1))
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_206 = [
  _hoisted_204,
  _hoisted_205
]
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "exceso medicamento"
}, "EXCESO DE MEDICAMENTO:", -1))
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SI", -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "NO", -1))
const _hoisted_210 = [
  _hoisted_208,
  _hoisted_209
]
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Alertas, Gestión de Citas Médicas Especializadas")
], -1))
const _hoisted_212 = { class: "grid" }
const _hoisted_213 = { class: "form-check form-switch" }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_psiqui"
}, "PSIQUIATRIA", -1))
const _hoisted_215 = { class: "form-check form-switch" }
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_geria"
}, "GERIATRIA", -1))
const _hoisted_217 = { class: "form-check form-switch" }
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_orto"
}, "ORTOPEDIA", -1))
const _hoisted_219 = { class: "form-check form-switch" }
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_gastro"
}, "GASTROENTEROLOGIA", -1))
const _hoisted_221 = { class: "form-check form-switch" }
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_oftal"
}, "OFTALMOLOGIA", -1))
const _hoisted_223 = { class: "form-check form-switch" }
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_psicolo"
}, "PSICOLOGIA", -1))
const _hoisted_225 = { class: "form-check form-switch" }
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_neurolo"
}, "NEUROLOGIA", -1))
const _hoisted_227 = { class: "form-check form-switch" }
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_fisia"
}, "FISIATRIA", -1))
const _hoisted_229 = { class: "form-check form-switch" }
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_cardio"
}, "CARDIOLOGIA", -1))
const _hoisted_231 = { class: "form-check form-switch" }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_odonto"
}, "ODONTOLOGIA", -1))
const _hoisted_233 = { class: "form-check form-switch" }
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_urolo"
}, "UROLOGIA", -1))
const _hoisted_235 = { class: "form-check form-switch" }
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "specialist_appo_diabe"
}, "DIABETOLOGIA", -1))
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Alertas, Levantamiento de necesidad del Adulto Mayor")
], -1))
const _hoisted_238 = { class: "grid" }
const _hoisted_239 = { class: "form-check form-switch" }
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Andador 4 Ruedas"
}, "ANDADOR DE 4 RUEDAS", -1))
const _hoisted_241 = { class: "form-check form-switch" }
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Andador 4 Patas"
}, "ANDADOR DE 4 PATAS", -1))
const _hoisted_243 = { class: "form-check form-switch" }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Bastón"
}, "BASTON", -1))
const _hoisted_245 = { class: "form-check form-switch" }
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Bastón 4 P"
}, "BASTON DE 4 PATAS", -1))
const _hoisted_247 = { class: "form-check form-switch" }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Bastón No VIdente"
}, "BASTON BLANCO (NO VIDENTE)", -1))
const _hoisted_249 = { class: "form-check form-switch" }
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Cama de Posición"
}, "CAMA DE POSICION", -1))
const _hoisted_251 = { class: "form-check form-switch" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Colchón Aire"
}, "COLCHON DE AIRE", -1))
const _hoisted_253 = { class: "form-check form-switch" }
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Faja Obdominal"
}, "FAJA ABDOMINAL", -1))
const _hoisted_255 = { class: "form-check form-switch" }
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Glucómetro"
}, "GLUCOMETRO", -1))
const _hoisted_257 = { class: "form-check form-switch" }
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Inodoro Porta"
}, "INODORO PORTATIL", -1))
const _hoisted_259 = { class: "form-check form-switch" }
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Muletas"
}, "MULETAS", -1))
const _hoisted_261 = { class: "form-check form-switch" }
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Pampers XL"
}, "PAMPERS XL", -1))
const _hoisted_263 = { class: "form-check form-switch" }
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Pampers L"
}, "PAMPERS L", -1))
const _hoisted_265 = { class: "form-check form-switch" }
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Pampers M"
}, "PAMPERS M", -1))
const _hoisted_267 = { class: "form-check form-switch" }
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Pampers S"
}, "PAMPERS S", -1))
const _hoisted_269 = { class: "form-check form-switch" }
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Silla de Baño"
}, "SILLA DE BAÑO", -1))
const _hoisted_271 = { class: "form-check form-switch" }
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "Media de Comprensión"
}, "MEDIA DE COMPRESION", -1))
const _hoisted_273 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Entrega de Suplementación Oral")
], -1))
const _hoisted_274 = { class: "grid" }
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "kit"
}, "KIT:", -1))
const _hoisted_276 = ["disabled"]
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "KIT 1", -1))
const _hoisted_278 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "KIT 2A", -1))
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "KIT 2B", -1))
const _hoisted_280 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "KIT 3", -1))
const _hoisted_281 = [
  _hoisted_277,
  _hoisted_278,
  _hoisted_279,
  _hoisted_280
]
const _hoisted_282 = { class: "form-check form-switch" }
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "cambioKit"
}, "CAMBIO DE KIT", -1))
const _hoisted_284 = { class: "grid" }
const _hoisted_285 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "justificacionCambioKit"
}, "JUSTIFICACION CAMBIO DE KIT:", -1))
const _hoisted_286 = { class: "grid" }
const _hoisted_287 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "comentary"
}, "COMENTARIO SUPERVISOR:", -1))
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "comentaryNutri"
}, "COMENTARIO NUTRICIONISTA:", -1))
const _hoisted_289 = ["disabled"]
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_291 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_292 = [
  _hoisted_290,
  _hoisted_291
]
const _hoisted_293 = ["disabled"]
const _hoisted_294 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_295 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_296 = [
  _hoisted_294,
  _hoisted_295
]
const _hoisted_297 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print" }, null, -1))
const _hoisted_298 = /*#__PURE__*/_createTextVNode(" Imprimir ")
const _hoisted_299 = [
  _hoisted_297,
  _hoisted_298
]
const _hoisted_300 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_301 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_302 = [
  _hoisted_300,
  _hoisted_301
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                  class: "img",
                  src: 'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
                }, null, 8, _hoisted_2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.showModalSSIRS)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("header", null, [
                _hoisted_5,
                _createElementVNode("a", {
                  target: "_blank",
                  href: this.$store.state.user.consultasAfiliados
                }, _hoisted_8, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalSSIRSMethod())),
                  for: "btn-modal",
                  class: "close"
                }, "Cerrar"),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    class: "flyer2",
                    src: this.$store.state.user.consultasAfiliados
                  }, null, 8, _hoisted_11)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showModalAseguradoras)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "search",
                      type: "search",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                      class: "form-control",
                      onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscar()))
                    }, null, 544), [
                      [_vModelText, _ctx.search]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("table", _hoisted_17, [
                      _hoisted_18,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCentros, (centro, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          onClick: ($event: any) => (_ctx.setCentro(centro))
                        }, [
                          _createElementVNode("td", null, _toDisplayString(centro.unap), 1),
                          _createElementVNode("td", null, _toDisplayString(centro.region), 1),
                          _createElementVNode("td", null, _toDisplayString(centro.provincia), 1)
                        ], 8, _hoisted_19))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_20, [
        (_ctx.showModalConfirm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (this.showModalConfirmMethod())),
                    for: "btn-modal"
                  }, "X"),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("button", {
                      class: "btn btn-success",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (this.showModalConfirmMethod()), ["prevent"]))
                    }, " Validar Otro Afiliado "),
                    _createElementVNode("button", {
                      class: "btn btn-info",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (this.$router.push('/evaluacions')), ["prevent"]))
                    }, " Ver Listado ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.encabezado), 1),
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", null, [
                _hoisted_29,
                _withDirectives(_createElementVNode("div", _hoisted_30, _hoisted_33, 512), [
                  [_vShow, _ctx.showSpinner]
                ]),
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "cedula",
                  type: "cedula",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.defCedula())),
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.evaluacion.cedula) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.cedula]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "nombre",
                  type: "nombre",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.evaluacion.nombre) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.nombre]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_35,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "apellido",
                  type: "apellido",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.evaluacion.apellido) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.apellido]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_36,
                _withDirectives(_createElementVNode("select", {
                  disabled: "",
                  id: "sexo",
                  type: "sexo",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.evaluacion.sexo) = $event)),
                  class: "form-select"
                }, _hoisted_39, 512), [
                  [_vModelSelect, _ctx.evaluacion.sexo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_40,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "fechaNacimiento",
                  type: "date",
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.calcularEdad(_ctx.evaluacion.fechaNacimiento))),
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.evaluacion.fechaNacimiento) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.fechaNacimiento]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_41,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "edad",
                  type: "Number",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.evaluacion.edad) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.edad]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_42,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "nss",
                  type: "nss",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.evaluacion.nss) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.nss]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_43,
                _withDirectives(_createElementVNode("select", {
                  disabled: "",
                  id: "regimen",
                  type: "regimen",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.evaluacion.regimen) = $event)),
                  class: "form-select"
                }, _hoisted_47, 512), [
                  [_vModelSelect, _ctx.evaluacion.regimen]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_48,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "direccion",
                  type: "direccion",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.evaluacion.direccion) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.direccion]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_49,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "telefono",
                  type: "telefono",
                  onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.defTelefono())),
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.evaluacion.telefono) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.telefono]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_50,
                _withDirectives(_createElementVNode("select", {
                  disabled: "",
                  id: "tipo_de_contacto",
                  type: "tipo_de_contacto",
                  onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setContactName())),
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.evaluacion.tipo_de_contacto) = $event)),
                  class: "form-select"
                }, _hoisted_55, 544), [
                  [_vModelSelect, _ctx.evaluacion.tipo_de_contacto]
                ])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _hoisted_56,
                _withDirectives(_createElementVNode("input", {
                  id: "especificacion_contacto",
                  type: "especificacion_contacto",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.evaluacion.especificacion_contacto) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.especificacion_contacto]
                ])
              ], 512), [
                [_vShow, this.evaluacion.tipo_de_contacto == 'OTROS']
              ]),
              _createElementVNode("div", null, [
                _hoisted_57,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "nombre_contacto",
                  type: "nombre_contacto",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.evaluacion.nombre_contacto) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.nombre_contacto]
                ])
              ])
            ]),
            _hoisted_58,
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", null, [
                  _hoisted_61,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "fecha",
                    type: "date",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.evaluacion.fecha) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.evaluacion.fecha]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_62,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "unap",
                    type: "unap",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.evaluacion.unap) = $event)),
                    class: "form-control",
                    onFocus: _cache[25] || (_cache[25] = ($event: any) => (this.showModalAseguradorasMethod()))
                  }, null, 544), [
                    [_vModelText, _ctx.evaluacion.unap]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_63,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "supervisor",
                    type: "supervisor",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.evaluacion.supervisor) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.evaluacion.supervisor]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_64,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "nombre_doctor",
                    type: "nombre_doctor",
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.evaluacion.nombre_doctor) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.evaluacion.nombre_doctor]
                  ])
                ])
              ])
            ]),
            _hoisted_65,
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", null, [
                _hoisted_67,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "talla",
                  type: "Number",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.evaluacion.talla) = $event)),
                  class: "form-control",
                  onChange: _cache[29] || (_cache[29] = ($event: any) => (
                    this.calcPctoGrasa(
                      this.evaluacion.cintura,
                      this.evaluacion.pliegue_bicep,
                      this.evaluacion.pliegue_abdominal,
                      this.evaluacion.pliegue_sub,
                      this.evaluacion.talla
                    )
                  ))
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.talla]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_68,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[30] || (_cache[30] = ($event: any) => (
                    this.calcularImc(
                      this.evaluacion.peso,
                      this.evaluacion.talla
                    )
                  )),
                  id: "peso",
                  type: "Number",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.evaluacion.peso) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.peso]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_69,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[32] || (_cache[32] = ($event: any) => (
                    this.calcPctoGrasa(
                      this.evaluacion.cintura,
                      this.evaluacion.pliegue_bicep,
                      this.evaluacion.pliegue_abdominal,
                      this.evaluacion.pliegue_sub,
                      this.evaluacion.talla
                    )
                  )),
                  id: "cintura",
                  type: "Number",
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.evaluacion.cintura) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.cintura]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_70,
                _withDirectives(_createElementVNode("input", {
                  id: "abdomen",
                  type: "Number",
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.evaluacion.abdomen) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.abdomen]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_71,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[35] || (_cache[35] = ($event: any) => (
                    _ctx.calcCintCader(
                      this.evaluacion.cintura,
                      this.evaluacion.cadera
                    )
                  )),
                  id: "cadera",
                  type: "Number",
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.evaluacion.cadera) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.cadera]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_72,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[37] || (_cache[37] = ($event: any) => (
                    _ctx.calcTalla(
                      this.evaluacion.altura_rodilla,
                      this.evaluacion.sexo,
                      this.evaluacion.edad
                    )
                  )),
                  id: "altura_rodilla",
                  type: "Number",
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.evaluacion.altura_rodilla) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.altura_rodilla]
                ])
              ])
            ]),
            _hoisted_73,
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", null, [
                _hoisted_75,
                _withDirectives(_createElementVNode("input", {
                  id: "presion_arterial_sistolica",
                  type: "Number",
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.evaluacion.presion_arterial_sistolica) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.presion_arterial_sistolica]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_76,
                _withDirectives(_createElementVNode("input", {
                  id: "presion_arterial_diatolica",
                  type: "Number",
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.evaluacion.presion_arterial_diatolica) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.presion_arterial_diatolica]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_77,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.cualificarFC(_ctx.evaluacion.frecuencia_cardiaca))),
                  id: "frecuencia_cardiaca",
                  type: "Number",
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.evaluacion.frecuencia_cardiaca) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.frecuencia_cardiaca]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_78,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[43] || (_cache[43] = ($event: any) => (
                    _ctx.cualificarFuerza(
                      this.evaluacion.fuerza,
                      this.evaluacion.sexo
                    )
                  )),
                  id: "fuerza",
                  type: "Number",
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.evaluacion.fuerza) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.fuerza]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_79,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "estadoFuerza",
                  type: "estadoFuerza",
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.evaluacion.estadoFuerza) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.estadoFuerza]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", null, [
                _hoisted_81,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "imc",
                  type: "Number",
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.evaluacion.imc) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.imc]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_82,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "estadoImc",
                  type: "estadoImc",
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.evaluacion.estadoImc) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.estadoImc]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_83,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[48] || (_cache[48] = ($event: any) => (_ctx.fixFlexibilidad_miembro_superior())),
                  id: "flexibilidad_miembro_superior",
                  type: "Number",
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.evaluacion.flexibilidad_miembro_superior) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.flexibilidad_miembro_superior]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_84,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[50] || (_cache[50] = ($event: any) => (_ctx.fixFlexibilidad_miembro_inferior())),
                  id: "flexibilidad_miembro_inferior",
                  type: "Number",
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.evaluacion.flexibilidad_miembro_inferior) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.flexibilidad_miembro_inferior]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", null, [
                _hoisted_86,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[52] || (_cache[52] = ($event: any) => (
                    this.calcPctoGrasa(
                      this.evaluacion.cintura,
                      this.evaluacion.pliegue_bicep,
                      this.evaluacion.pliegue_abdominal,
                      this.evaluacion.pliegue_sub,
                      this.evaluacion.talla
                    )
                  )),
                  id: "pliegue_bicep",
                  type: "Number",
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.evaluacion.pliegue_bicep) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.pliegue_bicep]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_87,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[54] || (_cache[54] = ($event: any) => (
                    this.calcPctoGrasa(
                      this.evaluacion.cintura,
                      this.evaluacion.pliegue_bicep,
                      this.evaluacion.pliegue_abdominal,
                      this.evaluacion.pliegue_sub,
                      this.evaluacion.talla
                    )
                  )),
                  id: "pliegue_abdominal",
                  type: "Number",
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.evaluacion.pliegue_abdominal) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.pliegue_abdominal]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_88,
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[56] || (_cache[56] = ($event: any) => (
                    this.calcPctoGrasa(
                      this.evaluacion.cintura,
                      this.evaluacion.pliegue_bicep,
                      this.evaluacion.pliegue_abdominal,
                      this.evaluacion.pliegue_sub,
                      this.evaluacion.talla
                    )
                  )),
                  id: "pliegue_sub",
                  type: "Number",
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.evaluacion.pliegue_sub) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.pliegue_sub]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_89,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "pctoGrasa",
                  type: "Number",
                  "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.evaluacion.pctoGrasa) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.pctoGrasa]
                ])
              ])
            ]),
            _hoisted_90,
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", null, [
                _hoisted_92,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[59] || (_cache[59] = ($event: any) => (this.calcRiesgoNutricional())),
                  id: "eval_nutri_1",
                  type: "eval_nutri_1",
                  "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.evaluacion.eval_nutri_1) = $event)),
                  class: "form-select"
                }, _hoisted_95, 544), [
                  [_vModelSelect, _ctx.evaluacion.eval_nutri_1]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_96,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[61] || (_cache[61] = ($event: any) => (this.calcRiesgoNutricional())),
                  id: "eval_nutri_2",
                  type: "eval_nutri_2",
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.evaluacion.eval_nutri_2) = $event)),
                  class: "form-select"
                }, _hoisted_99, 544), [
                  [_vModelSelect, _ctx.evaluacion.eval_nutri_2]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_100,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[63] || (_cache[63] = ($event: any) => (this.calcRiesgoNutricional())),
                  id: "eval_nutri_3",
                  type: "eval_nutri_3",
                  "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.evaluacion.eval_nutri_3) = $event)),
                  class: "form-select"
                }, _hoisted_103, 544), [
                  [_vModelSelect, _ctx.evaluacion.eval_nutri_3]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_104,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[65] || (_cache[65] = ($event: any) => (this.calcRiesgoNutricional())),
                  id: "eval_nutri_4",
                  type: "eval_nutri_4",
                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.evaluacion.eval_nutri_4) = $event)),
                  class: "form-select"
                }, _hoisted_107, 544), [
                  [_vModelSelect, _ctx.evaluacion.eval_nutri_4]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_108,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[67] || (_cache[67] = ($event: any) => (this.calcRiesgoNutricional())),
                  id: "eval_nutri_5",
                  type: "eval_nutri_5",
                  "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.evaluacion.eval_nutri_5) = $event)),
                  class: "form-select"
                }, _hoisted_111, 544), [
                  [_vModelSelect, _ctx.evaluacion.eval_nutri_5]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_112,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[69] || (_cache[69] = ($event: any) => (this.calcRiesgoNutricional())),
                  id: "eval_nutri_6",
                  type: "eval_nutri_6",
                  "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.evaluacion.eval_nutri_6) = $event)),
                  class: "form-select"
                }, _hoisted_115, 544), [
                  [_vModelSelect, _ctx.evaluacion.eval_nutri_6]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_116,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[71] || (_cache[71] = ($event: any) => (this.calcRiesgoNutricional())),
                  id: "eval_nutri_7",
                  type: "eval_nutri_7",
                  "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.evaluacion.eval_nutri_7) = $event)),
                  class: "form-select"
                }, _hoisted_119, 544), [
                  [_vModelSelect, _ctx.evaluacion.eval_nutri_7]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_120,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[73] || (_cache[73] = ($event: any) => (this.calcRiesgoNutricional())),
                  id: "eval_nutri_8",
                  type: "eval_nutri_8",
                  "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.evaluacion.eval_nutri_8) = $event)),
                  class: "form-select"
                }, _hoisted_123, 544), [
                  [_vModelSelect, _ctx.evaluacion.eval_nutri_8]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_124,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[75] || (_cache[75] = ($event: any) => (this.calcRiesgoNutricional())),
                  id: "eval_nutri_9",
                  type: "eval_nutri_9",
                  "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.evaluacion.eval_nutri_9) = $event)),
                  class: "form-select"
                }, _hoisted_127, 544), [
                  [_vModelSelect, _ctx.evaluacion.eval_nutri_9]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_128,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[77] || (_cache[77] = ($event: any) => (this.calcRiesgoNutricional())),
                  id: "eval_nutri_10",
                  type: "eval_nutri_10",
                  "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.evaluacion.eval_nutri_10) = $event)),
                  class: "form-select"
                }, _hoisted_131, 544), [
                  [_vModelSelect, _ctx.evaluacion.eval_nutri_10]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_132,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "riesgoNutricional",
                  type: "riesgoNutricional",
                  "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.evaluacion.riesgoNutricional) = $event)),
                  class: "form-select"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.riesgoNutricional]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_133, [
              _hoisted_134,
              _createElementVNode("div", _hoisted_135, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "true_radio_eval_nutri_1",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.evaluacion.eval_nutri_1) = $event)),
                    value: "SI"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_1]
                  ]),
                  _hoisted_136
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "false_radio_eval_nutri_1",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.evaluacion.eval_nutri_1) = $event)),
                    value: "NO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_1]
                  ]),
                  _hoisted_137
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_138, [
              _hoisted_139,
              _createElementVNode("div", _hoisted_140, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "true_radio_eval_nutri_2",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.evaluacion.eval_nutri_2) = $event)),
                    value: "SI"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_2]
                  ]),
                  _hoisted_141
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "false_radio_eval_nutri_2",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.evaluacion.eval_nutri_2) = $event)),
                    value: "NO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_2]
                  ]),
                  _hoisted_142
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_143, [
              _hoisted_144,
              _createElementVNode("div", _hoisted_145, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "true_radio_eval_nutri_3",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.evaluacion.eval_nutri_3) = $event)),
                    value: "SI"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_3]
                  ]),
                  _hoisted_146
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "false_radio_eval_nutri_3",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.evaluacion.eval_nutri_3) = $event)),
                    value: "NO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_3]
                  ]),
                  _hoisted_147
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_148, [
              _hoisted_149,
              _createElementVNode("div", _hoisted_150, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "true_radio_eval_nutri_4",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.evaluacion.eval_nutri_4) = $event)),
                    value: "SI"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_4]
                  ]),
                  _hoisted_151
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "false_radio_eval_nutri_4",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.evaluacion.eval_nutri_4) = $event)),
                    value: "NO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_4]
                  ]),
                  _hoisted_152
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_153, [
              _hoisted_154,
              _createElementVNode("div", _hoisted_155, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "true_radio_eval_nutri_5",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.evaluacion.eval_nutri_5) = $event)),
                    value: "SI"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_5]
                  ]),
                  _hoisted_156
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "false_radio_eval_nutri_5",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.evaluacion.eval_nutri_5) = $event)),
                    value: "NO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_5]
                  ]),
                  _hoisted_157
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_158, [
              _hoisted_159,
              _createElementVNode("div", _hoisted_160, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "true_radio_eval_nutri_6",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.evaluacion.eval_nutri_6) = $event)),
                    value: "SI"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_6]
                  ]),
                  _hoisted_161
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "false_radio_eval_nutri_6",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.evaluacion.eval_nutri_6) = $event)),
                    value: "NO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_6]
                  ]),
                  _hoisted_162
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_163, [
              _hoisted_164,
              _createElementVNode("div", _hoisted_165, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "true_radio_eval_nutri_7",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.evaluacion.eval_nutri_7) = $event)),
                    value: "SI"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_7]
                  ]),
                  _hoisted_166
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "false_radio_eval_nutri_7",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.evaluacion.eval_nutri_7) = $event)),
                    value: "NO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_7]
                  ]),
                  _hoisted_167
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_168, [
              _hoisted_169,
              _createElementVNode("div", _hoisted_170, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "true_radio_eval_nutri_8",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.evaluacion.eval_nutri_8) = $event)),
                    value: "SI"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_8]
                  ]),
                  _hoisted_171
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "false_radio_eval_nutri_8",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.evaluacion.eval_nutri_8) = $event)),
                    value: "NO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_8]
                  ]),
                  _hoisted_172
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_173, [
              _hoisted_174,
              _createElementVNode("div", _hoisted_175, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "true_radio_eval_nutri_9",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.evaluacion.eval_nutri_9) = $event)),
                    value: "SI"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_9]
                  ]),
                  _hoisted_176
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "false_radio_eval_nutri_9",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.evaluacion.eval_nutri_9) = $event)),
                    value: "NO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_9]
                  ]),
                  _hoisted_177
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_178, [
              _hoisted_179,
              _createElementVNode("div", _hoisted_180, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "true_radio_eval_nutri_10",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.evaluacion.eval_nutri_10) = $event)),
                    value: "SI"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_10]
                  ]),
                  _hoisted_181
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "false_radio_eval_nutri_10",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.evaluacion.eval_nutri_10) = $event)),
                    value: "NO"
                  }, null, 512), [
                    [_vModelRadio, _ctx.evaluacion.eval_nutri_10]
                  ]),
                  _hoisted_182
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_183, [
              _hoisted_184,
              _withDirectives(_createElementVNode("input", {
                disabled: "",
                id: "riesgoNutricional",
                type: "riesgoNutricional",
                "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.evaluacion.riesgoNutricional) = $event)),
                class: "form-select"
              }, null, 512), [
                [_vModelText, _ctx.evaluacion.riesgoNutricional]
              ])
            ]),
            _hoisted_185,
            _createElementVNode("div", _hoisted_186, [
              _createElementVNode("div", null, [
                _hoisted_187,
                _withDirectives(_createElementVNode("select", {
                  id: "Encamado",
                  type: "Encamado",
                  "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((_ctx.evaluacion.Encamado) = $event)),
                  class: "form-select"
                }, _hoisted_190, 512), [
                  [_vModelSelect, _ctx.evaluacion.Encamado]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_191,
                _withDirectives(_createElementVNode("select", {
                  id: "Edentulo",
                  type: "Edentulo",
                  "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.evaluacion.Edentulo) = $event)),
                  class: "form-select"
                }, _hoisted_194, 512), [
                  [_vModelSelect, _ctx.evaluacion.Edentulo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_195,
                _withDirectives(_createElementVNode("select", {
                  id: "vive solo",
                  type: "vive solo",
                  "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.evaluacion['vive solo']) = $event)),
                  class: "form-select"
                }, _hoisted_198, 512), [
                  [_vModelSelect, _ctx.evaluacion['vive solo']]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_199,
                _withDirectives(_createElementVNode("select", {
                  id: "abandono",
                  type: "abandono",
                  "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => ((_ctx.evaluacion.abandono) = $event)),
                  class: "form-select"
                }, _hoisted_202, 512), [
                  [_vModelSelect, _ctx.evaluacion.abandono]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_203,
                _withDirectives(_createElementVNode("select", {
                  id: "maltrato",
                  type: "maltrato",
                  "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => ((_ctx.evaluacion.maltrato) = $event)),
                  class: "form-select"
                }, _hoisted_206, 512), [
                  [_vModelSelect, _ctx.evaluacion.maltrato]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_207,
                _withDirectives(_createElementVNode("select", {
                  id: "exceso medicamento",
                  type: "exceso medicamento",
                  "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => ((_ctx.evaluacion['exceso medicamento']) = $event)),
                  class: "form-select"
                }, _hoisted_210, 512), [
                  [_vModelSelect, _ctx.evaluacion['exceso medicamento']]
                ])
              ])
            ]),
            _hoisted_211,
            _createElementVNode("div", _hoisted_212, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_213, [
                  _hoisted_214,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((_ctx.evaluacion['specialist_appo_psiqui']) = $event)),
                    id: "specialist_appo_psiqui"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_psiqui']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_215, [
                  _hoisted_216,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[108] || (_cache[108] = ($event: any) => ((_ctx.evaluacion['specialist_appo_geria']) = $event)),
                    id: "specialist_appo_geria"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_geria']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_217, [
                  _hoisted_218,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((_ctx.evaluacion['specialist_appo_orto']) = $event)),
                    id: "specialist_appo_orto"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_orto']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_219, [
                  _hoisted_220,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => ((_ctx.evaluacion['specialist_appo_gastro']) = $event)),
                    id: "specialist_appo_gastro"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_gastro']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_221, [
                  _hoisted_222,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => ((_ctx.evaluacion['specialist_appo_oftal']) = $event)),
                    id: "specialist_appo_oftal"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_oftal']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_223, [
                  _hoisted_224,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => ((_ctx.evaluacion['specialist_appo_psicolo']) = $event)),
                    id: "specialist_appo_psicolo"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_psicolo']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_225, [
                  _hoisted_226,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => ((_ctx.evaluacion['specialist_appo_neurolo']) = $event)),
                    id: "specialist_appo_neurolo"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_neurolo']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_227, [
                  _hoisted_228,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => ((_ctx.evaluacion['specialist_appo_fisia']) = $event)),
                    id: "specialist_appo_fisia"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_fisia']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_229, [
                  _hoisted_230,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event: any) => ((_ctx.evaluacion['specialist_appo_cardio']) = $event)),
                    id: "specialist_appo_cardio"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_cardio']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_231, [
                  _hoisted_232,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[116] || (_cache[116] = ($event: any) => ((_ctx.evaluacion['specialist_appo_odonto']) = $event)),
                    id: "specialist_appo_odonto"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_odonto']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_233, [
                  _hoisted_234,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((_ctx.evaluacion['specialist_appo_urolo']) = $event)),
                    id: "specialist_appo_urolo"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_urolo']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_235, [
                  _hoisted_236,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => ((_ctx.evaluacion['specialist_appo_diabe']) = $event)),
                    id: "specialist_appo_diabe"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['specialist_appo_diabe']]
                  ])
                ])
              ])
            ]),
            _hoisted_237,
            _createElementVNode("div", _hoisted_238, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_239, [
                  _hoisted_240,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => ((_ctx.evaluacion['Andador 4 Ruedas']) = $event)),
                    id: "Andador 4 Ruedas"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Andador 4 Ruedas']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_241, [
                  _hoisted_242,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event: any) => ((_ctx.evaluacion['Andador 4 Patas']) = $event)),
                    id: "Andador 4 Patas"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Andador 4 Patas']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_243, [
                  _hoisted_244,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event: any) => ((_ctx.evaluacion.Bastón) = $event)),
                    id: "Bastón"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion.Bastón]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_245, [
                  _hoisted_246,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event: any) => ((_ctx.evaluacion['Bastón 4 P']) = $event)),
                    id: "Bastón 4 P"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Bastón 4 P']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_247, [
                  _hoisted_248,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event: any) => ((_ctx.evaluacion['Bastón No VIdente']) = $event)),
                    id: "Bastón No VIdente"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Bastón No VIdente']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_249, [
                  _hoisted_250,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => ((_ctx.evaluacion['Cama de Posición']) = $event)),
                    id: "Cama de Posición"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Cama de Posición']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_251, [
                  _hoisted_252,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event: any) => ((_ctx.evaluacion['Colchón Aire']) = $event)),
                    id: "Colchón Aire"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Colchón Aire']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_253, [
                  _hoisted_254,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event: any) => ((_ctx.evaluacion['Faja Obdominal']) = $event)),
                    id: "Faja Obdominal"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Faja Obdominal']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_255, [
                  _hoisted_256,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[127] || (_cache[127] = ($event: any) => ((_ctx.evaluacion.Glucómetro) = $event)),
                    id: "Glucómetro"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion.Glucómetro]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_257, [
                  _hoisted_258,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event: any) => ((_ctx.evaluacion['Inodoro Porta']) = $event)),
                    id: "Inodoro Porta"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Inodoro Porta']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_259, [
                  _hoisted_260,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[129] || (_cache[129] = ($event: any) => ((_ctx.evaluacion.Muletas) = $event)),
                    id: "Muletas"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion.Muletas]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_261, [
                  _hoisted_262,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[130] || (_cache[130] = ($event: any) => ((_ctx.evaluacion['Pampers XL']) = $event)),
                    id: "Pampers XL"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Pampers XL']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_263, [
                  _hoisted_264,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[131] || (_cache[131] = ($event: any) => ((_ctx.evaluacion['Pampers L']) = $event)),
                    id: "Pampers L"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Pampers L']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_265, [
                  _hoisted_266,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[132] || (_cache[132] = ($event: any) => ((_ctx.evaluacion['Pampers M']) = $event)),
                    id: "Pampers M"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Pampers M']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_267, [
                  _hoisted_268,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[133] || (_cache[133] = ($event: any) => ((_ctx.evaluacion['Pampers S']) = $event)),
                    id: "Pampers S"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Pampers S']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_269, [
                  _hoisted_270,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[134] || (_cache[134] = ($event: any) => ((_ctx.evaluacion['Silla de Baño']) = $event)),
                    id: "Silla de Baño"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Silla de Baño']]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_271, [
                  _hoisted_272,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[135] || (_cache[135] = ($event: any) => ((_ctx.evaluacion['Media de Comprensión']) = $event)),
                    id: "Media de Comprensión"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['Media de Comprensión']]
                  ])
                ])
              ])
            ]),
            _hoisted_273,
            _createElementVNode("div", _hoisted_274, [
              _createElementVNode("div", null, [
                _hoisted_275,
                _withDirectives(_createElementVNode("select", {
                  disabled: !_ctx.evaluacion['cambioKit'],
                  id: "kit",
                  type: "kit",
                  "onUpdate:modelValue": _cache[136] || (_cache[136] = ($event: any) => ((_ctx.evaluacion.kit) = $event)),
                  class: "form-select"
                }, _hoisted_281, 8, _hoisted_276), [
                  [_vModelSelect, _ctx.evaluacion.kit]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_282, [
                  _hoisted_283,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[137] || (_cache[137] = ($event: any) => ((_ctx.evaluacion['cambioKit']) = $event)),
                    id: "cambioKit"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.evaluacion['cambioKit']]
                  ])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_284, [
              _createElementVNode("div", null, [
                _hoisted_285,
                _withDirectives(_createElementVNode("textarea", {
                  id: "justificacionCambioKit",
                  type: "justificacionCambioKit",
                  "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event: any) => ((_ctx.evaluacion.justificacionCambioKit) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.justificacionCambioKit]
                ])
              ])
            ], 512), [
              [_vShow, _ctx.evaluacion['cambioKit']]
            ]),
            _createElementVNode("div", _hoisted_286, [
              _createElementVNode("div", null, [
                _hoisted_287,
                _withDirectives(_createElementVNode("textarea", {
                  disabled: "",
                  id: "comentary",
                  rows: "3",
                  type: "comentary",
                  "onUpdate:modelValue": _cache[139] || (_cache[139] = ($event: any) => ((_ctx.evaluacion.comentary) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.comentary]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_288,
                _withDirectives(_createElementVNode("textarea", {
                  rows: "3",
                  id: "comentaryNutri",
                  type: "comentaryNutri",
                  "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event: any) => ((_ctx.evaluacion.comentaryNutri) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.comentaryNutri]
                ])
              ])
            ]),
            _createElementVNode("button", {
              disabled: 
                !_ctx.evaluacion.peso ||
                  !_ctx.evaluacion.cintura ||
                  !_ctx.evaluacion.abdomen ||
                  !_ctx.evaluacion.cadera ||
                  !_ctx.evaluacion.altura_rodilla ||
                  !_ctx.evaluacion.presion_arterial_sistolica ||
                  !_ctx.evaluacion.presion_arterial_diatolica ||
                  !_ctx.evaluacion.frecuencia_cardiaca ||
                  !_ctx.evaluacion.fuerza ||
                  !_ctx.evaluacion.estadoFuerza ||
                  !_ctx.evaluacion.pliegue_bicep ||
                  !_ctx.evaluacion.pliegue_abdominal ||
                  !_ctx.evaluacion.pliegue_sub ||
                  !_ctx.evaluacion.pctoGrasa ||
                  !_ctx.evaluacion.imc ||
                  !_ctx.evaluacion.estadoImc ||
                  !_ctx.evaluacion.eval_nutri_1 ||
                  !_ctx.evaluacion.eval_nutri_2 ||
                  !_ctx.evaluacion.eval_nutri_3 ||
                  !_ctx.evaluacion.eval_nutri_4 ||
                  !_ctx.evaluacion.eval_nutri_5 ||
                  !_ctx.evaluacion.eval_nutri_6 ||
                  !_ctx.evaluacion.eval_nutri_7 ||
                  !_ctx.evaluacion.eval_nutri_8 ||
                  !_ctx.evaluacion.eval_nutri_9 ||
                  !_ctx.evaluacion.eval_nutri_10 ||
                  !_ctx.evaluacion.Encamado ||
                  !_ctx.evaluacion.Edentulo ||
                  !_ctx.evaluacion['vive solo'] ||
                  !_ctx.evaluacion.abandono ||
                  !_ctx.evaluacion.maltrato ||
                  !_ctx.evaluacion['exceso medicamento']
              ,
              class: "btn btn-primary",
              onClick: _cache[141] || (_cache[141] = _withModifiers(($event: any) => (_ctx.createEvaluacion()), ["prevent"]))
            }, _hoisted_292, 8, _hoisted_289),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "imageInput",
                type: "file",
                ref: "fileInput",
                onInput: _cache[142] || (_cache[142] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                accept: "image/*"
              }, null, 544), [
                [_vShow, false]
              ])
            ]),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-success",
                  onClick: _cache[143] || (_cache[143] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
                  disabled: 
                !_ctx.evaluacion.facNo ||
                  !_ctx.evaluacion.nombPres ||
                  !_ctx.evaluacion.codPres ||
                  !_ctx.evaluacion.aut ||
                  !_ctx.evaluacion.fechAutor ||
                  !_ctx.evaluacion.nombARS ||
                  !_ctx.evaluacion.autPor ||
                  !_ctx.evaluacion.montRec ||
                  !_ctx.evaluacion.nombPac ||
                  !_ctx.evaluacion.cedu ||
                  !_ctx.evaluacion.aflNSS ||
                  !_ctx.evaluacion.sex ||
                  !_ctx.evaluacion.edad ||
                  !_ctx.evaluacion.dir ||
                  !_ctx.evaluacion.dx
              
                }, _hoisted_296, 8, _hoisted_293))
              : _createCommentVNode("", true),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-warning",
                  onClick: _cache[144] || (_cache[144] = ($event: any) => (this.$router.push(`/evaluacions2/${_ctx.evaluacion._id}`)))
                }, _hoisted_299))
              : _createCommentVNode("", true),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-danger",
                  onClick: _cache[145] || (_cache[145] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_302))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}